// extracted by mini-css-extract-plugin
export var acitonButtons = "_ie-0";
export var additionalIcon = "_ie-f";
export var block = "_ie-1";
export var blockContent = "_ie-7";
export var blockDescription = "_ie-8";
export var blockIcon = "_ie-9";
export var blockTitle = "_ie-6";
export var border = "_ie-a";
export var center = "_ie-l";
export var edge = "_ie-b";
export var edgeLabel = "_ie-c";
export var edgePath = "_ie-d";
export var error = "_ie-e";
export var flowchart = "_ie-g";
export var flowchartContent = "_ie-h";
export var highlighted = "_ie-3";
export var hover = "_ie-4";
export var icon = "_ie-i";
export var left = "_ie-m";
export var navButton = "_ie-j";
export var navButtons = "_ie-k";
export var right = "_ie-n";
export var selected = "_ie-2";
export var small = "_ie-5";